import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { waterFillingMachines } from '../../mock/mockData';

const WaterFilling120BPM = () => {
  const productData = waterFillingMachines.find(p => p.id === 'wfm-120');
  return <ProductPageTemplate productData={productData} />;
};

export default WaterFilling120BPM;